import { useOutletContext } from 'react-router-dom';

import { OutletContext } from 'types';

export default function useUser() {
  const { user } = useOutletContext<OutletContext>();
  return user;
}
